import React, { useContext } from 'react';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import AppContext from 'context/Context';

const TrialBanner = () => {
  const { t } = useTranslation();
  const { userData } = useContext(AppContext);

  const account = userData?.company?.account;
  if (!account || account.status !== 'trial' || !account.trial_end) return null;

  const trialEnd = moment(account.trial_end);
  const daysLeft = Math.max(0, trialEnd.diff(moment(), 'days'));

  return (
    <Alert variant={daysLeft <= 3 ? 'danger' : 'warning'} className="mb-0 rounded-0 text-center py-2">
      <strong>{t('TRIAL_BANNER.TITLE')}</strong>{' '}
      {daysLeft > 0
        ? t('TRIAL_BANNER.DAYS_LEFT', { days: daysLeft, date: trialEnd.format('MMM D, YYYY') })
        : t('TRIAL_BANNER.EXPIRED')}
    </Alert>
  );
};

export default TrialBanner;
